/* eslint-disable react-hooks/exhaustive-deps */
import { MutableRefObject, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import {
  clearFaq,
  faq,
  searchFaq,
  searchFaqByDesc,
} from "../../store/modules/FaqStore";

import { getUserDetails, user } from "../../store/modules/UserStore";

import Select, { OptionTypeBase } from "react-select";

import {
  createSimpleRequest,
  getRules,
  rule,
  sendRuleRequest,
  setMode,
  setRules,
  updateUserInfo,
} from "../../store/modules/RuleStore";

import {
  request,
  createSuccess,
  getAreas,
  getServices,
  getDepartments,
  getLocations,
  ISelect,
  setAutofillRequestData,
  getTorres,
  getPisos,
  setSelfServiceConfiguration,
  getSelfServiceConfiguration,
  cleanStore,getParameter
} from "../../store/modules/RequestStore";

import { getTemplate, marketPlace } from "../../store/modules/MarketPlaceStore";

import { cleanStore as cleanStoreMarketPlace } from "../../store/modules/MarketPlaceStore";

import {
  AdjuntarArchivoDiv,
  ErrorModalBtn,
  InputAndDisplayFile,
  NewRequestContainer,
  NewRequestForm,
  NormalInput,
  NormalInputsFields,
  RelatedArticles,
  SubmitButtons,
} from "../../components/CreateRequestPage/createRequestElements";

import {
  TabFaq,
  TabRule,
  DisplayedFile,
  FilePaste,
} from "../../components/CreateRequestPage/createRequest";

import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";

import "@progress/kendo-theme-default/dist/all.css";

import "react-phone-input-2/lib/style.css";
import { Modal } from "../../components/widgets/Popup";
import { toast, ToastContainer } from "react-toastify";

import { UsernameService } from "../../services/LocalStorage";
import { searchTermTimeout } from "../../utils/TimeOut";

import environment from "environment";
import React from "react";
import API from "../../services/API";

import { AiOutlineReload } from "react-icons/ai";
import { IconContext } from "react-icons/lib";
import { useTranslation } from "react-i18next";
import { useTranslationContext } from "../../context/TranslationContext";
import TranslatableText from "../../components/Multilanguage/TranslatableText";

type RuleSelected = {
  id: string;
  name: string;
};

const {
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignRight,
  AlignCenter,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  Undo,
  Redo,
  Unlink,
} = EditorTools;

const editorTools: any = [
  [Bold, Italic, Underline],
  [Undo, Redo],
  [Link, Unlink],
  [AlignLeft, AlignCenter, AlignRight],
  [OrderedList, UnorderedList, Indent, Outdent],
];

const CreateRequest = () => {
  const dispatch = useDispatch();
  const { targetLang } = useTranslationContext(); 
  const configurationSelf = useSelector(request);
  const userDetails = useSelector(user);
  const ruleStore = useSelector(rule);
  const searchTimeout: MutableRefObject<any> = useRef();

  const [loading, setLoading] = useState(true);
  const [disableRule, setDisableRule] = useState(userDetails.disableRule);

  const editor: any = React.createRef();

  const { t } = useTranslation();

  const getEditorContent = (): string => {
    let editorContent = "";

    if (editor.current) {
      const view = editor.current.view;

      if (view) {
        editorContent = EditorUtils.getHtml(view.state) ?? "";
      }
    }

    return editorContent;
  };

  const setEditorContent = (content: string): void => {
    if (editor.current) {
      const view = editor.current.view;

      if (view) {
        EditorUtils.setHtml(view, content);
      }
    }
  };

  useEffect(() => {
    dispatch(searchFaq(" ", undefined, true));
    dispatch(getUserDetails(setLoading,setDisableRule))
  }, []);

  useEffect(() => {
    const userInfo: any = UsernameService.get();

    dispatch(
      setSelfServiceConfiguration({
        areMandatoryFields: false,
        areVisibleFields: false,
      })
    );
    setTimeout(() => {
      dispatch(getSelfServiceConfiguration());
    }, 2000);
    dispatch(setAutofillRequestData());
    dispatch(getAreas(userDetails.username));
    dispatch(getDepartments());
    dispatch(getLocations(userDetails.CompanyID));
    dispatch(getTorres(userInfo.CompanyID));
    dispatch(getPisos(userInfo.TowerID));
    return () => {
      dispatch(setMode(0));
      dispatch(cleanStore());
      dispatch(cleanStoreMarketPlace());
    };
  }, [dispatch, userDetails.CompanyID, userDetails.username]);

  const marketPlaceStore = useSelector(marketPlace);
  const faqs = useSelector(faq);
  const requestState = useSelector(request);
  const rules = useSelector(rule);

  const [redirect, setRedirect] = useState(false);

  const [ruleSelected, setRuleSelected] = useState<RuleSelected>({
    id: "",
    name: "",
  });

  const [CIInput, setCIInput] = useState<OptionTypeBase>({
    value: "",
    label: "---",
  });

  const [email, setEmail] = useState(requestState.autofillData.UserMail);

  const [telefono, setTelefono] = useState(
    requestState.autofillData.UserTelephone
  );

  const [extension, setExtension] = useState(
    requestState.autofillData.UserExtension
  );

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(false);
  const [files, setFiles] = useState<File[]>([]);
const [activoBtn, setActivoBtn] = useState(false);
  const [buttonActive, setButtonActive] = useState(true);

  const [selectedUser] = useState<OptionTypeBase>({
    value: userDetails.CompanyID + " " + userDetails.username,
    label: userDetails.name + " " + userDetails.lastName,
  });

  const [areaSelected, setAreaSelected] = useState<OptionTypeBase>({
    value: "",
    label: "---",
  });

  const [locationSelected, setLocationSelected] = useState<OptionTypeBase>({
    value: requestState.autofillData.UserLocationValue,
    label: requestState.autofillData.UserLocationText,
  });

  const [serviceSelected, setServiceSelected] = useState<OptionTypeBase>({
    value: "",
    label: "---",
  });

  const [torreSelected, setTorreSelected] = useState<OptionTypeBase>({
    value: requestState.autofillData.UserTowerValue,
    label: requestState.autofillData.UserTowerText,
  });

  const [pisoSelected, setPisoSelected] = useState<OptionTypeBase>({
    value: requestState.autofillData.UserFloorValue,
    label: requestState.autofillData.UserFloorText,
  });

  const [departmentSelected, setDepartmentSelected] = useState<OptionTypeBase>({
    value: requestState.autofillData.UserDepartmentValue,
    label: requestState.autofillData.UserDepartmentText,
  });

  useEffect(() => {
          const fetchParameter = async () => {
            const paramShowLang = await getParameter({ parameterName: "BotonCrearSolicitud" });
            if (
              paramShowLang?.data?.status === "Ok" &&
              paramShowLang.data.values.parameterValue.toString() === "1"
            ) {
              setActivoBtn(true);
            } 
          };
      
          fetchParameter();
        }, []);
  // useEffect(() => {}, [dispatch, selectedUser]);

  const handleSubject = (e: any) => {
    const searchTerm = e.target.value;

    setSubject(searchTerm);

    if (searchTerm === "") {
      dispatch(searchFaq(" ", undefined, true));
      return;
    }

    clearTimeout(searchTimeout.current);

    searchTimeout.current = setTimeout(() => {
      dispatch(searchFaq(searchTerm, undefined, true));
    }, searchTermTimeout);
  };

  function showErrorMessage(message: string) {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  function updateUserInformation(userInformation: any): void {
    dispatch(
      updateUserInfo(
        userInformation.Username,
        userInformation.Email,
        userInformation.Phone,
        userInformation.Extention,
        userInformation.DepartmentID,
        userInformation.Location,
        userInformation.TowerId,
        userInformation.FloorId
      )
    );
  }

  function validateFields(): boolean {
    return (
      subject &&
      getEditorContent() &&
      selectedUser.value &&
      email &&
      telefono &&
      extension &&
      departmentSelected.value &&
      locationSelected.value &&
      torreSelected.value &&
      pisoSelected.value &&
      pisoSelected.value > 0 &&
      serviceSelected.value
    );
  }

  function createRequest(): void {
    const cleanDescription: string = html2text(getEditorContent());
    setLoading(true);
    if (cleanDescription === "") return;

    dispatch(
      createSimpleRequest(
        subject,
        getEditorContent(),
        userDetails.username,
        selectedUser.value.split(" ")[1],
        userDetails.CompanyID,
        selectedUser.value.split(" ")[0],
        serviceSelected.value,
        CIInput.value,
        files,
        email,
        telefono,
        extension,
        locationSelected.value,
        departmentSelected.value,
        setLoading
      )
    );

    dispatch(setMode(0));

    if (
      userDetails.username !== selectedUser.value.split(" ")[1] &&
      userDetails.CompanyID === selectedUser.value.split(" ")[0]
    ) {
      dispatch(createSuccess(true));
      setRedirect(true);
    }

    if (
      userDetails.username === selectedUser.value.split(" ")[1] &&
      userDetails.CompanyID === selectedUser.value.split(" ")[0]
    )
      dispatch(createSuccess(true));

    clearRules();
  }

  function html2text(html: string) {
    var tag = document.createElement("div");
    tag.innerHTML = html;

    return tag.innerText;
  }

  useEffect(() => {
    clearTimeout(searchTimeout.current);

    searchTimeout.current = setTimeout(() => {
      dispatch(searchFaqByDesc(html2text(description)));
    }, searchTermTimeout);
  }, [description, dispatch]);

  const handleCancelRulesChoice = () => dispatch(setMode(0));

  const clearRules = () => {
    dispatch(setRules());
    dispatch(clearFaq());
    setButtonActive(true);
  };

  const handleRequest = (e: any) => {
    e.preventDefault();

    if (disableRule === false) {
      const requestDescription = getEditorContent();
      switch (rules.mode) {
        case 0:
          if (subject !== "" && requestDescription !== "<p></p>") {
            dispatch(
              getRules(
                subject,
                requestDescription,
                userDetails.username,
                selectedUser.value.split(" ")[1],
                userDetails.CompanyID,
                selectedUser.value.split(" ")[0],
                CIInput.value,
                files,
                email,
                telefono,
                extension,
                locationSelected.value,
                departmentSelected.value
              )
            )
            setButtonActive(false);
          } else {
            setError(true);
          }
          break;
        case 1:
          dispatch(setMode(0));
          if (userDetails.CompanyID === selectedUser.value.split(" ")[0])
            dispatch(createSuccess(true));
          clearRules();
          break;
        case 2:
          dispatch(
            sendRuleRequest(
              subject,
              getEditorContent(),
              ruleSelected.id,
              userDetails.username,
              selectedUser.value.split(" ")[1],
              userDetails.CompanyID,
              selectedUser.value.split(" ")[0],
              CIInput.value,
              files,
              email,
              telefono,
              extension,
              locationSelected.value,
              departmentSelected.value
            )
          );
          dispatch(setMode(0));
          if (userDetails.CompanyID === selectedUser.value.split(" ")[0])
            dispatch(createSuccess(true));
          clearRules();
          break;
        case 3:
          if (requestState.selfServiceConfiguration.areVisibleFields) {
            let userInfoPayload = {
              Username: selectedUser.value.split(" ")[1],
              Email: email,
              Phone: telefono,
              Extention: extension,
              DepartmentID: Number.parseInt(departmentSelected.value),
              Location: locationSelected.value,
              TowerId: Number.parseInt(torreSelected.value),
              FloorId: Number.parseInt(pisoSelected.value),
            };

            if (requestState.selfServiceConfiguration.areMandatoryFields) {
              if (validateFields()) {
                updateUserInformation(userInfoPayload);
                createRequest();
              } else {
                showErrorMessage(t("createRequest.showErrors.completeAllFields"));
              }
            } else {
              //Si el campo esta deshabilitado se realiza este proceso para crear la solicitud
              if (serviceSelected.value) {
                if (subject && getEditorContent()) {
                  updateUserInformation(userInfoPayload);
                  createRequest();
                } else {
                  showErrorMessage(
                    t("createRequest.showErrors.subjectAndDescription")
                  );
                }
              } else {
                showErrorMessage(t("createRequest.showErrors.completeServiceField"));
              }
            }
          } else {
            if (serviceSelected.value) {
              if (subject && getEditorContent()) {
                createRequest();
              } else {
                showErrorMessage(
                  t("createRequest.showErrors.subjectAndDescription")
                );
              }
            } else {
              showErrorMessage(t("createRequest.showErrors.completeServiceField"));
            }
          }
          break;
        default:
          break;
      }
    } else {
      if (areaSelected.value && serviceSelected.value) {
        if (subject !== "" && getEditorContent() !== "<p></p>") {
          createRequest();
        } else {
          setError(true);
        }
      } else {
        showErrorMessage(t("createRequest.showErrors.selectAreaAndService"));
      }
    }
  };

  const handleAreaChange = async (e: ISelect) => {
    const { label, value } = e;
    dispatch(getServices(userDetails.username, e.value));
    setAreaSelected({ ...selectedUser, label: label, value: value });
    setServiceSelected({ ...selectedUser, value: "", label: "---" });
  };

  const handleDepartmentChange = (e: ISelect) => {
    const { label, value } = e;
    setDepartmentSelected({ ...selectedUser, label: label, value: value });
  };

  const handleLocationChange = (e: ISelect) => {
    const { label, value } = e;
    setLocationSelected({ ...selectedUser, label: label, value: value });
  };

  const handleTorreChange = (e: ISelect) => {
    const { label, value } = e;

    cleanPisoSelected();

    dispatch(getPisos(value));
    setTorreSelected({ ...selectedUser, label: label, value: value });
  };

  const handlePisoChange = (e: ISelect) => {
    const { label, value } = e;
    setPisoSelected({ ...selectedUser, label: label, value: value });
  };

 const handleServiceChange = (e: any) => {
  if (!e) {
    setServiceSelected(null); // o setServiceSelected(undefined) según cómo lo manejes
    setButtonActive(false);   // desactiva el botón si se limpió
    return;
  }

  const { label, value } = e;
  setServiceSelected({ ...selectedUser, label, value });
  setButtonActive(true);
  dispatch(getTemplate(value));
};


  useEffect(() => {
    guideTemplateForService();
  }, [marketPlaceStore.template?.TemplateDescription]);


  const guideTemplateForService = (): void => {
    const { template } = marketPlaceStore;

    const description = template?.TemplateDescription || "";

    if (description !== "") {
      setDescription(description);
      setEditorContent(description);
    }
  };

  const handleCancelCreate = (_e: any) => {
    setRedirect(true);
  };

  function cleanPisoSelected(): void {
    pisoSelected.label = "";
    pisoSelected.value = "";
  }

  const handleChange = (selectorFiles: FileList) => {
    const formData = new FormData();
    // console.log("data", files);
    for (const name in selectorFiles) {
      formData.append(name, selectorFiles[name]);
    }
    const filesToUpload = [...files, ...Object.values(selectorFiles)];
    filesToUpload.map((item) => {
      setFiles([...filesToUpload.filter((item) => item.size < 55000000)]);
    });

  };

  const customStyles = {
    option: (provided: any, _state: any) => ({
      ...provided,
    }),
    control: (_provided: any, state: any) => ({
      display: "flex",
      border: "1px solid white",
      borderRadius: "7px",
      width: "100%",
      margin: "0",
      borderColor: state.isFocused ? "#dce6e6" : "white",
      "&:hover": {
        borderColor: "#dce6e6",
      },
    }),
    dropdownIndicator: (provided: any, _state: any) => ({
      ...provided,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: () => ({
      display: "none",
    }),
  };

  const hiddenStyle: any = {
    display: requestState.selfServiceConfiguration.areVisibleFields
      ? "contents"
      : "none",
  };

  const mandatoryFieldStyle: any = {
    display: requestState.selfServiceConfiguration.areMandatoryFields
      ? "contents"
      : "none",
  };
  if (rules.requestID !== "") {
    // const url: string = `${environment.api.url}/File/UploadResource`;
    // const formData = new FormData();
    // files.map((file) => {
    //   formData.append("files", file);
    // });
    // API()
    //   .post(url, formData, {
    //     headers: {
    //       "x-helppeople-appcode": 1,
    //       "x-helppeople-actioncode": 1,
    //       "x-helppeople-useraction": userDetails.username || "",
    //       "x-helppeople-registerid": rules.requestID,
    //     },
    //   })
    //   .then((response) => {
    //     console.log("correcto", response);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    // console.log("archivos", files);
    // setFiles([]);

  }

  return (
    <>
 
      {loading ? (
        <p className="h-screen flex justify-center items-center">
          {t("createRequest.loading")}...
          <IconContext.Provider
            value={{
              color: "#868a91",
              className: "animate-spin h-8 w-8 ",
            }}
          >
            <AiOutlineReload />
          </IconContext.Provider>
        </p>
      ) : (
        <NewRequestContainer>
         {redirect && <Redirect to="/request/all" />}
          {rules.requestID !== "" && (
            <Redirect to={`/request/${rules.requestID}`} />
          )} 
           {rules.requestID === "-1" && <Redirect to="/request/all" />} 
          <NewRequestForm>
            <div className="flex justify-end mt-12 gap-3">
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  marginRight: "auto",
                }}
              >
                <Link to={"/"}>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 17L6 12M6 12L11 7M6 12L18 12"
                      stroke="#111827"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
              <SubmitButtons
                color="#3948ff"
                bg="white"
                type="button"
                onClick={(e: any) => handleCancelCreate(e)}
              >
                {t("cancelButton")}
              </SubmitButtons>
              <SubmitButtons
                type="submit"
                disabled={ruleStore.isCallingServer}
                onClick={(e: any) => handleRequest(e)}
                bg="#3948ff"
                color="white"
                hoverChange
              >
                {t("createButton")}
              </SubmitButtons>
            </div>
            <h1 className="text-xl text-azulMedio">
              {t("createRequest.title")}
            </h1>
               {
     !activoBtn && configurationSelf.selfServiceConfiguration.activateNewRequest ===
          false &&(<Redirect to={`/MarketPlace/index`} />)
  }
            {disableRule !== false && (
              <div className="" style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%", marginRight: "10px" }}>
                  <label
                    className="w-full text-gray-500 break-words mt-3 text-md"
                    htmlFor="solicitante"
                  >
                    {t("createRequest.labelArea")}{" "}
                    <span className="text-red-600 text-md font-bold">*</span>
                  </label>
                  <div>
                    <Select
                      style={{ zindex: 999 }}
                      defaultValue={areaSelected}
                      onChange={(e) => handleAreaChange(e)}
                      options={requestState.areas.map((data) => {
                        return {
                          ...data,
                          label:  targetLang !== "es" ? <TranslatableText text={data.label} /> : data.label,
                        };
                      })}
                    ></Select>
                  </div>
                </div>
                <div style={{ width: "50%" }}>
                  <label
                    className="w-full text-gray-500 break-words mt-3 text-md"
                    htmlFor="solicitante"
                  >
                    {t("createRequest.labelService")}{" "}
                    <span className="text-red-600 text-md font-bold">*</span>
                  </label>
                  <div>
                    <Select
                      value={serviceSelected}
                      isClearable
                      onChange={(e) => handleServiceChange(e)}
                      options={requestState.services.map((data) => {
                        return {
                          ...data,
                          label:  targetLang !== "es" ? <TranslatableText text={data.label} /> : data.label,
                        };
                      })}
                    ></Select>
                  </div>
                </div>
              </div>
            )}
            <NormalInputsFields>
              <label
                className="w-full text-gray-500 break-words mt-3 text-md"
                htmlFor="solicitante"
              >
                {t("createRequest.labelSubject")}{" "}
                <span className="text-red-600 text-md font-bold">*</span>
              </label>
              <NormalInput
                maxLength="80"
                value={subject}
                onChange={(e: any) => handleSubject(e)}
                type="text"
                placeholder={t("createRequest.placeholderSubject")}
              />
            </NormalInputsFields>
            <div className="flex flex-col w-full">
              <label
                className="w-full text-gray-500 break-words mt-3 text-md"
                htmlFor="solicitante"
              >
                {t("createRequest.labelDescription")}{" "}
                <span className="text-red-600 text-md font-bold">*</span>
              </label>

              <Editor
                ref={editor}
                tools={editorTools}
                contentStyle={{
                  height: 350,
                }}
                defaultContent={description}
              />
            </div>

            {/** Inicio campos del formulario de usuario */}

            <div style={hiddenStyle}>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="email"
                >
                  {t("createRequest.labelEmail")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <NormalInput
                  color="#00B446"
                  type="email"
                  onChange={(e: any) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                  placeholder={t("createRequest.placeholderEmail")}
                />
              </NormalInputsFields>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="teléfono"
                >
                  {t("createRequest.labelPhone")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <NormalInput
                  value={telefono}
                  onChange={(e: any) => setTelefono(e.target.value)}
                  placeholder={t("createRequest.placeholderPhone")}
                />
              </NormalInputsFields>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="extensión"
                >
                  {t("createRequest.labelExtension")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <NormalInput
                  value={extension}
                  onChange={(e: any) => setExtension(e.target.value)}
                  type="text"
                  placeholder="####"
                />
              </NormalInputsFields>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="departamento"
                >
                  {t("createRequest.labelInternalArea")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <Select
                  defaultValue={departmentSelected}
                  onChange={(e) => handleDepartmentChange(e)}
                  inpu
                  options={requestState.departments}
                  styles={customStyles}
                />
              </NormalInputsFields>
              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="ubicación"
                >
                  {t("createRequest.labelLocation")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <Select
                  defaultValue={locationSelected}
                  onChange={(e) => handleLocationChange(e)}
                  options={requestState.locations}
                  styles={customStyles}
                />
              </NormalInputsFields>

              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="torre"
                >
                  {t("createRequest.labelTower")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <Select
                  defaultValue={torreSelected}
                  onChange={(e) => handleTorreChange(e)}
                  options={requestState.torres}
                  styles={customStyles}
                />
              </NormalInputsFields>

              <NormalInputsFields>
                <label
                  className="w-full text-gray-500 break-words mt-3 text-md"
                  htmlFor="piso"
                >
                  {t("createRequest.labelFloor")}{" "}
                  <span
                    style={mandatoryFieldStyle}
                    className="text-red-600 text-md font-bold"
                  >
                    *
                  </span>
                </label>
                <Select
                  value={pisoSelected}
                  onChange={(e) => handlePisoChange(e)}
                  options={requestState.pisos}
                  styles={customStyles}
                />
              </NormalInputsFields>
            </div>

            {/** Fin de campos del formulario de usuario */}

            <AdjuntarArchivoDiv>
              <FilePaste
                files={files}
                setFiles={setFiles}
                handleChange={handleChange}
              />
              <InputAndDisplayFile>
                {files?.length > 0 &&
                  files.map((file: File, _index: number) => {
                    return (
                      <DisplayedFile
                        singleFile={file}
                        files={files}
                        setFiles={setFiles}
                      />
                    );
                  })}
              </InputAndDisplayFile>
            </AdjuntarArchivoDiv>

            {/* <Modal
          active={error}
          setModalActive={setError}
          alert={true}
          height="25%"
          width="30%"
        >
          <div className="flex items-center justify-center h-full w-full flex-col gap-28">
            <h1>Debes completar los campos obligatorios!</h1>
            <ErrorModalBtn onClick={() => setError(false)} bg="#3DEA83">
              Entendido
            </ErrorModalBtn>
          </div>
        </Modal> */}
            <Modal
              active={error}
              setModalActive={setError}
              alert={true}
              height="25%"
              width="30%"
            >
              {/* <div className="flex items-center justify-center h-full w-full flex-col gap-28">
            <h1>Debes completar los campos obligatorios!</h1> */}
              <h4 className="font-bold text-center lg:mt-2 mb-2 text-red-600 text-md ">
                {t("createRequest.modalMandatoryFields.completeFields")}
              </h4>
              <p className="text-center text-gray-800 md:mb-14 lg:mb-13">
                {t("createRequest.modalMandatoryFields.emptyFields")}
              </p>
              <div className="flex items-center justify-center md-fixed">
                <ErrorModalBtn onClick={() => setError(false)} bg="#3DEA83">
                  {t("createRequest.modalMandatoryFields.agree")}
                </ErrorModalBtn>
              </div>

              {/* </div> */}
            </Modal>
          </NewRequestForm>
          <RelatedArticles>
            <div className="w-full h-full md:pt-8 md:pl-8">
              {rules.mode === 0 ? (
                <TabFaq
                  faqs={faqs}
                  subject={subject}
                  description={description}
                />
              ) : (
                <TabRule
                  subject={subject}
                  description={description}
                  rules={rules}
                  areaSelected={areaSelected}
                  serviceSelected={serviceSelected}
                  setButtonActive={setButtonActive}
                  setRuleSelected={setRuleSelected}
                  ruleSelected={ruleSelected}
                  handleAreaChange={handleAreaChange}
                  handleServiceChange={handleServiceChange}
                  requestState={requestState}
                  handleCancelRulesChoice={handleCancelRulesChoice}
                  clearRules={clearRules}
                />
              )}
            </div>
          </RelatedArticles>
        </NewRequestContainer>
      )}
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </>
  );
};

export default CreateRequest;
